import { render, staticRenderFns } from "./Plants.vue?vue&type=template&id=7ec0c2a7&scoped=true&"
import script from "./Plants.vue?vue&type=script&lang=ts&"
export * from "./Plants.vue?vue&type=script&lang=ts&"
import style0 from "./Plants.vue?vue&type=style&index=0&id=7ec0c2a7&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ec0c2a7",
  null
  
)

export default component.exports